module.exports = __webpack_public_path__ + "img/service1.bf381494.png";